import { forkJoin, Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

type Mapper<T> = (input: T) => any;

export const map = <T>(mapper: Mapper<T>) => (source: Observable<T[]>): Observable<any[]> =>
    source.pipe(
        concatMap((data: T[]) => (data.length > 0 ? forkJoin(data.map(mapper)) : of(data))),
    );
